<app-splash-header></app-splash-header>
<app-hero-header id="Home"></app-hero-header>
<app-client id="client"></app-client>
<section class="section">
    <div class="container">
        <div class="section-header mb-xl-5">
            <div class="header-start text-center">
                <h2 class="title">mobileWISE's User-Friendly Visual Development Interface with Drag-and-Drop Functionality</h2>
            </div>
        </div>
        <div class="image-container">
            <img src="assets/imgs/visual-development-interface-drag-and-drop.svg" class="w-100" alt="mobileWISE's user-friendly visual development interface with drag-and-drop functionality." loading="lazy">
        </div>
    </div>
 </section>
<app-concept id="Solutions"></app-concept>
<app-offer id="offer"></app-offer>
<app-pricing id="Price"></app-pricing>
<app-why-mobile-wise id="Contact"></app-why-mobile-wise>
<app-start-now id="Contact-email"></app-start-now>
<app-footer></app-footer>
